module.exports = __webpack_public_path__ + "static/media/camplus_ios.ca8f0fe6.png";